import React from 'react';
import PropTypes from 'prop-types';
import { Categories as PlatformCategories } from 'models/business/Platform';
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import SSCIcon from 'assets/SSC.png';
import CPASIcon from 'assets/CPAS.png';
import AdvertisingMethodButton from './AdvertisingMethodButton';
import Styles from './index.module.css';

const Contents = {
  [PlatformCategories.Google]: {
    title: '智慧型購物廣告',
    subTitle: 'Google SSC 智慧型購物平台',
    icon: SSCIcon,
  },
  [PlatformCategories.FacebookCarousel]: {
    title: '社群廣告',
    subTitle: 'Facebook CPAS 協作廣告',
    icon: CPASIcon,
  },
};

function AdvertisingWays({
  ad,
  onChangeAd,
}) {
  const expanded = !ad.platform && ad.advertisingGoal;
  return (
    <div>
      <div
        className={classNames(
          Styles.titleText,
          { [Styles.titleTextFocused]: !expanded },
        )}
      >
        選擇廣告方式
      </div>
      <div
        className={classNames(
          Styles.buttonGroup, { [Styles.buttonGroupExpanded]: expanded },
        )}
      >
        {Object.keys(Contents).map((platform) => (
          <AdvertisingMethodButton
            key={`method-button-${platform}`}
            title={Contents[platform].title}
            subTitle={Contents[platform].subTitle}
            src={Contents[platform].icon}
            onClick={() => {
              const newAd = ad.clone();
              newAd.platform = platform;
              onChangeAd(newAd);
            }}
            disabled={!ad.advertisingGoal}
            selected={platform === ad.platform}
            expanded={expanded}
          />
        ))}
      </div>
    </div>
  );
}

AdvertisingWays.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
};

AdvertisingWays.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
};

export default AdvertisingWays;
